import autobind from 'core-decorators/lib/autobind';

import decorate from 'widget/utils/decorate';
import { openFullScreenOverlay } from 'shared/utils/open-overlay';

import InFrameActions from './in-frame';


@decorate(InFrameActions)
export default class InOverlayActions extends React.Component {
  static propTypes = {
    children: React.PropTypes.element.isRequired,
    selectVideo: React.PropTypes.func.isRequired,
    playVideo: React.PropTypes.func.isRequired,
    channelId: React.PropTypes.string,
    videoId: React.PropTypes.string,
  };

  @autobind
  showVideoAtOverlay() {
    const { channelId, videoId } = this.props;
    openFullScreenOverlay(`#/channel/${channelId}/video/${videoId}`);
  }

  @autobind
  playVideoAtOverlay() {
    const { channelId, videoId } = this.props;
    openFullScreenOverlay(`#/channel/${channelId}/video/${videoId}/play`);
  }

  render() {
    const inFrameActions = _.omit(this.props, this.propTypes);

    return React.cloneElement(this.props.children, {
      ...inFrameActions,
      onClick: this.showVideoAtOverlay,
      onPlayRequest: this.playVideoAtOverlay,
      onPlayWithoutPreviewRequest: this.showVideoAtOverlay,
    });
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/actions/overlay-actions/in-overlay.js